import React, { useEffect, useState } from "react";
import Papa from "papaparse";

export default function GrowthComponent() {
  const [data, setData] = useState([]);
  const [headers, setHeaders] = useState([]);

  useEffect(() => {
    const formatter = new Intl.DateTimeFormat("en-CA", {
      timeZone: "America/New_York",
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    });
  const today_str = formatter.format(new Date());
  console.log(today_str);
    const dir =  `/data/growth/${today_str}`;
    const spx500GrowthCSV = `${dir}/spx_500_growth_rank.csv`;
    console.log(spx500GrowthCSV);

    fetch(spx500GrowthCSV)
      .then((res) => res.text())
      .then((csvText) => {
        const results = Papa.parse(csvText, { header: true, skipEmptyLines: true });
        setHeaders(results.meta.fields);
        setData(results.data);
      })
      .catch((err) => console.error("Error loading CSV:", err));
  }, []);

  return (
    <div className="p-4">
      <h2 className="text-xl font-bold mb-2">CSV Table Viewer</h2>

      {data.length > 0 && (
        <table className="border-collapse border border-gray-300 w-full text-left">
          <thead>
            <tr>
              {headers.map((header) => (
                <th
                  key={header}
                  className="border border-gray-300 px-2 py-1 bg-gray-100"
                >
                  {header}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {data.map((row, i) => (
              <tr key={i} className={i % 2 === 0 ? "bg-white" : "bg-gray-50"}>
                {headers.map((header) => (
                  <td key={header} className="border border-gray-600 px-2 py-1">
                    {row[header]}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}
